import {Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FormBuilder, ReactiveFormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {AuthServiceMock} from "../../../../auth/authentication-service-mock/auth.service.mock";
import {MatSelectModule} from "@angular/material/select";
import {ActivatedRoute} from "@angular/router";
import {Subject, takeUntil} from "rxjs";

@Component({
  selector: 'app-mock-auth-ui',
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule
  ],
  templateUrl: './mock-auth-ui.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mock-auth-ui.component.css'
})
export class MockAuthUiComponent implements OnInit, OnDestroy {
  destroySubject$ = new Subject<void>();

  // Injectables
  formBuilder = inject(FormBuilder);
  activatedRoute = inject(ActivatedRoute);
  authServiceMock = inject(AuthServiceMock);

  tokenFormControl = this.formBuilder.control('');

  ngOnInit() {
    this.tokenFormControl.valueChanges.pipe(takeUntil(this.destroySubject$)).subscribe(value => {
      if (value) {
        this.authServiceMock.setToken(value);
      }
    });

    this.activatedRoute.queryParams.pipe(takeUntil(this.destroySubject$)).subscribe(params => {
      const jwt = params['jwt'];

      if (jwt) {
        this.tokenFormControl.setValue(jwt as string ?? '');
      }
    })
  }

  ngOnDestroy() {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }
}
